var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompletedIcon = function SvgCompletedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32D583",
    d: "M17.02 0c9.4 0 17.021 7.62 17.021 17.02s-7.62 17.021-17.02 17.021S0 26.421 0 17.021 7.62 0 17.02 0m7.404 11.104a1.584 1.584 0 0 0-2.238.096l-7.59 8.281-2.79-2.789a1.584 1.584 0 0 0-2.239 2.24l3.96 3.958a1.58 1.58 0 0 0 2.286-.05l8.708-9.5a1.584 1.584 0 0 0-.097-2.236"
  })));
};
export default SvgCompletedIcon;